import styled from "styled-components";

export const StyledProjectName = styled.b`
    color: ${({ color = "#000" }) => color};
`;
